const appBaseUrl = '/app'
const secureRouteBuilder = (url: string) => appBaseUrl + url

export {secureRouteBuilder}
